<script>
  import { getId, addElement, getLayoutComponent } from './builder.js'
  import { createEventDispatcher, onDestroy } from 'svelte'
  import dayjs from 'dayjs'

  const dispatch = createEventDispatcher()

  export let variant = 'Default'
  export let config = { format: 'YYYY-MM-DD' }

  export let name = null
  export let value = null // always null or ISO86601 YYYY-MM-DD
  export let id = getId()
  export let placeholder = config.format
  export let autocomplete = null
  export let disabled = null
  export let readonly = null
  export let min = null // take ISO86601 YYYY-MM-DD
  export let max = null // take ISO86601 YYYY-MM-DD
  export let weekStart = 0
  export let language = 'en'

  // export let step support ?

  export let validate = null

  export let label = name || ''
  export let info = null
  export let required = null

  // value is always stored internally as ISO8601
  // $element.formatted is diplayed value

  const elementName = 'DateField'

  const element = addElement(v => {
    value = v
  })

  element.setFormatter(
    d => {
      if (d) {
        const parsed = dayjs(d, config.format)
        if (parsed.isValid()) {
          return parsed.format(config.format)
        }
      }
      return null
    },
    f => {
      // console.log('inside unformatter', f)
      const parsed = dayjs(f, config.format)
      if (parsed.isValid()) {
        return parsed.format('YYYY-MM-DD')
      }
    }
  )
  $: element.init({ value, validate, label, info, disabled, required, min, max, id })

  export const validateValue = element.validateValue

  onDestroy(element.selfDestroy)
</script>

<svelte:component
  this={getLayoutComponent(elementName)}
  let:inputClass
  {variant}
  {config}
  {id}
  {language}
  {weekStart}
  on:change={() => {
    dispatch('change')
  }}
  {elementName}
>
  {#if config.textType}
    <input
      bind:value={$element.formatted}
      type="text"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      on:focus
      on:blur
      on:input
      on:change
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
      style="width:100%"
    />
  {:else}
    <input
      bind:value={$element.value}
      type="date"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      on:focus
      on:blur
      on:input
      on:change
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
      style="width:100%"
    />
  {/if}
</svelte:component>
